<ng-container *ngIf="sectionName">
  <div class="remark-section__title">
    <span>{{ sectionName | translate }}</span>
  </div>
</ng-container>

<div class="remark-container">
  <ng-content></ng-content>
</div>
